import React, { memo, useCallback, useMemo } from 'react';

import { Box, Popper } from '@mui/material';
import PropTypes from 'prop-types';

import useTruncatedGeneral from 'hooks/useTruncatedGeneral';

import { popperStyles } from './AutocompleteCDS.styles';

const AutocompleteCDSPopper = ({ children, disablePortal = false, sx: sxProp, ...props }) => {
  const [onMouseOver, onResetTooltipState, TruncatedProvider] = useTruncatedGeneral();

  const onMouseOverWithStopPropagation = useCallback(
    e => {
      e.stopPropagation();
      onMouseOver(e);
    },
    [onMouseOver],
  );

  const mergedSx = useMemo(() => [popperStyles, sxProp], [sxProp]);

  return (
    <Popper {...props} disablePortal={disablePortal} sx={mergedSx}>
      <Box onMouseLeave={onResetTooltipState} onMouseOver={onMouseOverWithStopPropagation}>
        <TruncatedProvider />
        {children}
      </Box>
    </Popper>
  );
};

AutocompleteCDSPopper.propTypes = {
  children: PropTypes.node.isRequired,
  disablePortal: PropTypes.bool,
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
    PropTypes.func,
    PropTypes.object,
  ]),
};

export default memo(AutocompleteCDSPopper);
